import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import "./index.css";
import { checkConsentOnLoad } from "./lib/analytics";
import { registerWebMcpTools } from "./lib/webmcp";

// Initialize GA only if user previously consented
checkConsentOnLoad();

// Expose site tools to AI agents via the WebMCP API (if supported)
registerWebMcpTools();

const router = createBrowserRouter(routes);

createRoot(document.getElementById("root")!).render(<RouterProvider router={router} />);
